var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "default-modal",
    {
      attrs: {
        name: "invoice-export-modal",
        width: "md",
        title: _vm.$t("invoice_export_modal_title"),
        autofocus: _vm.$refs.customerSelect,
        actionLabel: _vm.$t("export"),
        successHandler: _vm.success ? null : _vm.handleExport
      },
      model: {
        value: _vm.modalOpened,
        callback: function($$v) {
          _vm.modalOpened = $$v
        },
        expression: "modalOpened"
      }
    },
    [
      !_vm.success
        ? _c(
            "template",
            { slot: "content" },
            [
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("invoice_export_modal_body"))
                }
              }),
              _c(
                "q-field",
                { attrs: { label: _vm.$tc("customer", 2), labelWidth: 4 } },
                [
                  _c("multi-customer-select", {
                    ref: "customerSelect",
                    model: {
                      value: _vm.formData.customer_id,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "customer_id", $$v)
                      },
                      expression: "formData.customer_id"
                    }
                  })
                ],
                1
              ),
              _c(
                "q-field",
                {
                  attrs: {
                    label: _vm.$t("invoice_date"),
                    labelWidth: 4,
                    error: _vm.errors.has("startDate"),
                    "error-label": _vm.errors.first("startDate")
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "row no-wrap justify-between" },
                    [
                      _c("q-datetime", {
                        attrs: {
                          type: "date",
                          name: "startDate",
                          format: _vm.$t("date_format"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.formData.startDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "startDate", $$v)
                          },
                          expression: "formData.startDate"
                        }
                      }),
                      _c("span", { staticClass: "on-right on-left" }, [
                        _vm._v(_vm._s(_vm.$t("to")))
                      ]),
                      _c("q-datetime", {
                        attrs: {
                          type: "date",
                          name: "endDate",
                          format: _vm.$t("date_format"),
                          clearable: ""
                        },
                        model: {
                          value: _vm.formData.endDate,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "endDate", $$v)
                          },
                          expression: "formData.endDate"
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _c(
                "q-field",
                { attrs: { label: _vm.$t("invoice_status"), labelWidth: 4 } },
                [
                  _c("q-select", {
                    attrs: { multiple: "", options: _vm.invoiceStatuses },
                    model: {
                      value: _vm.formData.status,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "status", $$v)
                      },
                      expression: "formData.status"
                    }
                  })
                ],
                1
              ),
              _c(
                "q-field",
                { attrs: { label: _vm.$t("export_format"), labelWidth: 4 } },
                [
                  _c("q-select", {
                    attrs: { options: _vm.formatOptions },
                    model: {
                      value: _vm.formData.format,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "format", $$v)
                      },
                      expression: "formData.format"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "template",
            { slot: "content" },
            [
              _c("check-mark"),
              _c("h4", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("export_successful_title")))
              ]),
              _c("p", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.$t("export_successful_body")))
              ])
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }